import React,{Component} from 'react'
import {AppSettings} from '../../configs'

class BreadCrumb extends Component{
    constructor(props){
        super(props)
    }

    render(){
        let breadcrumbList = [];
        for(let i = 0; i < this.props.breadcrumb.length ; i++){
            let isActive=false;
            let linkComponent;
            if(i === this.props.breadcrumb.length - 1){
                isActive = true;
                linkComponent = this.props.breadcrumb[i].name;
            }
            else{
                isActive = false;
                linkComponent = (<a href={`${'#' + this.props.breadcrumb[i].url}`}>{`${this.props.breadcrumb[i].name}`}</a>);
            }
            breadcrumbList.push((
                <li key={i} aria-current="page" className={`breadcrumb-item sp-breadcrumb-item ${isActive ? 'active' : ''}`} >
                    {linkComponent}
                </li>
            ));
        }
        return(
            <div className="breadcrumb-container sp-breadcrumb-container">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb sp-breadcrumb">
                    <li className="breadcrumb-item sp-breadcrumb-item"><a href={AppSettings.landingpageUrl}>Home</a></li>
                    {
                        breadcrumbList.map((item)=>(item))
                    }
                </ol>
            </nav>
        </div>
        )
    }
}

export default BreadCrumb